import styled from "styled-components/macro";

export const StyledNavbar = styled.nav`
  border: 1px solid #dfe3e8;
  width: 100%;

  background: #f4f6f8;

  position: sticky;
  top: 32px;
  z-index: 10;
`;
export const StyledList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  border-radius: 4px;
  li {
    padding: 22px 0;
  }
  a {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #575e68;
    text-decoration: none;
    letter-spacing: 0em;
    background: #fcfcfd;
    border: 1px solid #babfc3;
    border-radius: 4px;
    padding: 10px 14px;
    margin: 10px 0 10px 23px;
    &:hover {
      cursor: pointer;
    }
  }
`;
